import { ImageLazyLoadModule } from './../../../common/directives/image-lazy-load/image-lazy-load.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainlazyloadingComponent } from './mainlazyloading/mainlazyloading.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  exports:[MainlazyloadingComponent],
  declarations: [MainlazyloadingComponent],
  imports: [
    CommonModule,
    FormsModule,
    ImageLazyLoadModule,
    SharedModule,
  ]
})
export class LazyloadingModule { }

// translation loader moved to SharedModule
